// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-image-svg{\n    width: 12px;\n    height: 12px;\n    fill: #222;\n}\n.image-list-container .image-list-item{\n    height: 100px;\n    width: 100px;\n    border-radius: 4px;\n    border: 1px solid #D6D6D6;\n    overflow: hidden;\n}\n\n", ""]);
// Exports
module.exports = exports;
